<!-- סטטוס הפגישה as a row of chips, one per status (the meeting form, the meeting's summary): a click picks
     it, a click on the picked one takes it off. value = the meeting's meetingStatusId; @input = the new id
     (null = none). Each chip is outlined in its status's color and filled once picked. -->
<template>
    <div class="meetingStatusChips">
        <button v-for="status in options"
                :key="status.id"
                type="button"
                class="meetingStatusChip"
                :class="{ meetingStatusChipOn: status.id == value }"
                :style="chipStyle(status)"
                :disabled="disabled"
                :title="hint(status)"
                @click="pick(status)">
            <i v-if="status.id == value" class="fa-solid fa-check"></i>
            <i v-else-if="status.needsReschedule" class="fa-solid fa-rotate-right"></i>
            {{ status.name }}
        </button>
        <span v-if="!options.length" class="meetingStatusChipsEmpty">אין סטטוסים ברשימה - הוסיפו בניהול מהיר</span>
    </div>
</template>

<script>
import { inkOf, tintOf } from '../../services/calendar/calendar-colors';

export default {
    name: 'MeetingStatusChips',

    props: {
        value: { type: [Number, String], default: null },
        disabled: { type: Boolean, default: false },
    },

    computed: {
        // the statuses on the list now, and the meeting's own one even if it was taken off the list since
        options() {
            let options = this.$handlers.meetingHandler.statusOptions();
            let current = this.$handlers.meetingHandler.statusOf({ meetingStatusId: this.value });
            if (current && !options.some(status => status.id == current.id))
                options = options.concat([current]);
            return options;
        },
    },

    methods: {
        pick(status) {
            this.$emit('input', status.id == this.value ? null : status.id);
        },

        chipStyle(status) {
            let color = this.$handlers.meetingHandler.statusColor(status);
            let on = status.id == this.value;
            return {
                color: on ? '#fff' : inkOf(color),
                background: on ? color : tintOf(color, 0.06),
                borderColor: on ? color : tintOf(color, 0.45),
            };
        },

        hint(status) {
            let parts = [];
            if (status.cancelsMeeting)
                parts.push('הפגישה לא מתקיימת: יוצאת מיומן גוגל, בלי תזכורות, והשעה מתפנה לתיאום פגישות');
            if (status.needsReschedule)
                parts.push('הפגישה תופיע ב"לקביעה מחדש" במעקב פגישות עד שתיקבע פגישה במקומה');
            return parts.join('. ') || null;
        },
    },
};
</script>

<style>
.meetingStatusChips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.meetingStatusChips .meetingStatusChip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 14px;
    border: 1px solid #dcdfe6;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: background .15s ease, color .15s ease;
}

.meetingStatusChips .meetingStatusChip i {
    font-size: 11px;
    color: inherit !important;
}

.meetingStatusChips .meetingStatusChip:disabled {
    opacity: .6;
    cursor: default;
}

.meetingStatusChips .meetingStatusChipsEmpty {
    color: #8a8f9c;
    font-size: 13px;
}
</style>
